'use strict';
(() => {
  function initializeNavigation() {
    document.querySelectorAll('.jmo-header-refresh').forEach(header => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const mobileGroups = [...header.querySelectorAll('.jmo-mobile-group')];
      mobileGroups.forEach(group => {
        group.addEventListener('toggle', () => {
          if (group.open) mobileGroups.forEach(other => { if (other !== group) other.open = false; });
        });
      });
      header.addEventListener('click', event => {
        if (!event.target.closest('.jmo-menu-panel a, .jmo-navigation-panel a')) return;
        header.querySelectorAll('[data-header-details][open]').forEach(panel => { panel.open = false; });
        document.body.classList.remove('jmo-panel-open');
      });
      const desktop = window.matchMedia('(min-width: 1001px)');
      desktop.addEventListener('change', () => {
        header.querySelectorAll('[data-header-details][open]').forEach(panel => { panel.open = false; });
        document.body.classList.remove('jmo-panel-open');
      });
    });
  }
  initializeNavigation();
  document.addEventListener('shopify:section:load', initializeNavigation);
})();
